<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Technician" title="Works" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="row mb-3">
                                <div class="col-md-10">
									<div class="mm-cart-text">
										<div class="col-md-6">
											<table class="product_table">
												<thead style="font-size: medium;">
													<tr>
														<th>Technician Name</th>
														<th style="text-align: left;">:</th>
														<td style="text-align: right;">Technician 1</td>
													</tr> 
												</thead>
											</table>
										</div>
                                    </div>
								</div>
							    <div class="col-2">
                                    <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
							    </div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" >
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<!-- <div class="col-md-2 mt-2">
										<select class="form-select">
											<option value="">All</option>
                                            <option value="1">Active</option>
                                            <option value="2">Blocked</option>
										</select>
									</div> -->
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Customer</th>
											<th>Location</th>
											<th>Product</th>
											<th>Type</th>
											<th>Date</th>
											<th>Total Amount</th> 
                                            <th>Incentive Earned</th> 
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody>
                                        <tr align="center">
                                            <td>1</td>
											<td>
												Anil<br>
												+91 8373487383
											</td>
											<td>Bypass junction, Kommady, Alappuzha</td>
											<td>GPS</td>
											<td>New</td>
											<td>31 May 2025</td>
											<td>Rs.3000</td>
											<td>Rs.60</td>
                                            <td>
												<router-link :to="{ name: 'job_details' }" class="btn btn-primary btn-sm me-2 mb-2">Details</router-link><br>
                                            </td>
                                        </tr>
                                        <tr align="center">
                                            <td>2</td>
											<td>
												Ajo<br>
												+91 837321283
											</td>
											<td>Bypass junction, Kalarkode, Alappuzha</td>
											<td>Speed Governer</td>
											<td>Repair</td>
											<td>25 May 2025</td>
											<td>Rs.500</td>
											<td>Rs.20</td>
                                            <td>
												<router-link :to="{ name: 'job_details' }" class="btn btn-primary btn-sm me-2 mb-2">Details</router-link><br>
                                            </td>
                                        </tr>
                                      
                                    </tbody>
								</table>
							</div>

							<!----pagination starts --->
							<!-- <nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchNotifications(page.url + '&limit=' + listing_length + '&type=' + type + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> -->
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>

	export default {
		name: "Pincode Page",
		
		data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

                button_title: "Save",
                name: "",
				
			};
		},
		created() {

		},
		methods: {
			
		},
	};
</script>